import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Row, Table } from 'reactstrap'
import { apiAusenciasService } from 'services/apiAusenciasService';
import { apiFestivosService } from 'services/apiFestivosService';

const MesCalendarioEmpleado = (props) => {

    const daysInMonth = new Date(props.anno,  props.mes+1, 0).getDate();
    const firstDayOfMonth = new Date(props.anno, props.mes, 1).getDay();

    const [diasAusencias, setDiasAusencias] = useState([]);
    const [diasFestivos, setDiasFestivos] = useState([]);
   
    useEffect(() => {
      // obtener ausencias (sigue pidiendo por año+mes+empleado)
      const fetchData = async () =>{
        const responseAusencias = await apiAusenciasService.getByAnnoAndMesAndEmpleadoId(props.anno, props.nombreMes.toUpperCase(), props.empleado.id)
        setDiasAusencias(responseAusencias)
        const responseFestivos = await apiFestivosService.getByAnnoAndMesAndCentroId(props.anno, props.nombreMes.toUpperCase(), props.empleado.centroId)
        setDiasFestivos(responseFestivos.map(festivo => festivo.dia))
      }

      fetchData();

    }, [props.anno, props.mes, props.empleado, props.nombreMes])
    

    const weeks = [];
    let week = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      week.push(<div key={`empty-${i}`} className="col"></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const day = new Date(props.anno, props.mes, i);
      const dayOfWeek = day.getDay();
      const isFestivo = diasFestivos.includes(i)
      const isAusencia = diasAusencias.find((ausencia) => ausencia.dia === i)
      
      if(!isAusencia){
        week.push(
          <div key={i} className={`col ${isFestivo? "text-danger":""} text-right`} >
            {i<=9 ? "0"+i: i} 
          </div> );
      }else{
        let className = "";

        if(isAusencia.tipo ==="VACACIONES" ){
          className="text-info";
        }else if(isAusencia.tipo ==="BAJA" ){
          className="text-warning";
        }else if(isAusencia.tipo ==="AUSENCIA" ){
          className="text-yellow";
        }

        week.push(
          <div key={i} className={`col ${className} text-right`} x>
             {i<=9 ? "0"+i: i}
          </div> );
      }
        
     
      if (dayOfWeek === 6 || i === daysInMonth) {
        if (i === daysInMonth && dayOfWeek !== 6) {
            for (let j = dayOfWeek + 1; j <= 6; j++) {
              week.push(<div key={`empty-${j}`} className="col"></div>);
            }
          }
        weeks.push(<div key={weeks.length} className="row no-gutters" >{week}</div>);
        week = [];
      }
    }

  return (
    <>
    <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      {props.nombreMes} {props.anno}
                    </h6>
                   
                  </div>
                </Row>
              </CardHeader>
              <CardBody >
              <div className="calendar">
              <div className="row no-gutters">
                <div className="col text-right">D</div>
                <div className="col text-right">L</div>
                <div className="col text-right">M</div>
                <div className="col text-right">X</div>
                <div className="col text-right">J</div>
                <div className="col text-right">V</div>
                <div className="col text-right">S</div>
            </div>
          {weeks}
        </div>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
         
          </thead>
          <tbody>
          </tbody>
        </Table>

              </CardBody>

              
            </Card>

    </>
  )
}

export default MesCalendarioEmpleado